import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import "../App.css";

export default function LoginPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000);
  };

  const handleLogin = async () => {
    try {
      const result = await api.checkLoginInspection(userName, password);
      const table = result?.CheckLoginInspectionApi?.Table || [];
      const loginData = table[0];
      if (loginData?.Loginmsg === "Success") {
        showMessage("✅ Login Successful!", "success");
        sessionStorage.setItem("userName", loginData.UsrName);
        sessionStorage.setItem("userId", loginData.Usrid);
        navigate("/dashboard", { replace: true });
      } else {
        showMessage("❌ Username or Password incorrect", "error");
      }
    } catch (error) {
      console.error("Login failed:", error);
      showMessage("❌ Login Failed: " + error.message, "error");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <button onClick={handleBack} style={styles.backButton}>← Back</button>
        <h2 style={styles.title}>Inspection Portal Login</h2>

        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Username"
          style={styles.input}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={styles.input}
        />

        <button onClick={handleLogin} style={styles.button}>Login</button>

        {message && (
          <div
            style={{
              ...styles.toast,
              backgroundColor: message.type === "success" ? "#4caf50" : "#f44336",
            }}
          >
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center",
    width: "400px",
    maxWidth: "90%",
    position: "relative",
  },
  backButton: {
    position: "absolute",
    top: "20px",
    left: "20px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  backButtonHover: {
    backgroundColor: "#5a6268",
  },
  title: { fontSize: "22px", marginBottom: "20px", color: "#333" },
  input: {
    padding: "12px",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    marginBottom: "15px",
  },
  button: {
    backgroundColor: "#667eea",
    color: "#fff",
    padding: "12px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    width: "100%",
  },
  toast: {
    marginTop: "15px",
    padding: "10px",
    borderRadius: "8px",
    color: "#fff",
  },
};
